import { Component } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-shopify-affiliation',
  templateUrl: './shopify-affiliation.component.html',
  styleUrls: ['./shopify-affiliation.component.scss'],
})
export class ShopifyAffiliationComponent {
  url = this.translate.instant('home_intro_banner.partners')[1].url;

  constructor(private translate: TranslateService) {}
}
